import ContentsToReact from '@/components/ContentsToReact/ContentsToReact';
import GenericModals from '@/components/GenericModals/GenericModals';
import Page from '@/components/Page/Page';
import PageHead from '@/components/PageHead/PageHead';
import { extractContents } from '@/helpers/extractContents';
import extractPageMetaFromRouteData from '@/helpers/extractPageMetaFromRouteData';
import { useInitialPageDataLayer } from '@/hooks/useInitialPageDataLayer/useInitialPageDataLayer';
import type { PageModel } from '@/models/page';
import BackToTopButton from '@uikit/components/BackToTopButton/BackToTopButton';
import Layout from '@uikit/components/Layout/Layout';
import { LayoutVariant } from '@uikit/components/Layout/interfaces';
import cmsComponents from './ESolDefaultPage.cmsComponents';
import type { DefaultPageProps } from './interfaces';

const ESolDefaultPage = (pageData: PageModel<DefaultPageProps>) => {
  const currentPageData = pageData;

  const meta = extractPageMetaFromRouteData(currentPageData);

  const { contents } = currentPageData;

  const {
    extractedContents: [footerContents, noticeBarArea],
    restContents,
  } = extractContents(['esol-footer', 'notice-bar-area'], contents);

  useInitialPageDataLayer();

  return (
    <>
      <PageHead {...meta} />
      <Layout variant={LayoutVariant.Default}>
        {noticeBarArea && (
          <ContentsToReact
            contents={noticeBarArea}
            cmsComponents={cmsComponents}
          />
        )}

        <Page>
          {restContents && (
            <ContentsToReact
              contents={restContents}
              cmsComponents={cmsComponents}
            />
          )}
        </Page>

        <BackToTopButton />

        <ContentsToReact
          contents={footerContents}
          cmsComponents={cmsComponents}
        />
      </Layout>

      <GenericModals modals={pageData.modals} cmsComponents={cmsComponents} />
    </>
  );
};

export default ESolDefaultPage;
